import { inject, Injectable } from '@angular/core';
import { apiPath } from '../../../constants/api-routes';
import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { ApiResponse } from '../../../models';
import { Observable } from 'rxjs';
import { ClientModel } from '../models/Client.model';
import { LOADER_TOKEN } from '../../../tokens/http-context.token';
import { LoaderEnum } from '../../../enums/loader.enum';

@Injectable({ providedIn: 'root' })
export class ClientManagementService {
  private http = inject(HttpClient);

  fetchClientList(data: any, showLoader: boolean = false) {
    return this.http.post<
      ApiResponse<{ list: ClientModel[]; totalItems: number }>
    >(
      apiPath.clients.fetchClientList,
      data,
      showLoader
        ? undefined
        : {
            context: new HttpContext().set(LOADER_TOKEN, LoaderEnum.SPINNER),
          },
    );
  }

  fetchClientsAssociatedWithUser(data: any, showLoader: boolean = false) {
    return this.http.post<
      ApiResponse<{ list: ClientModel[]; totalItems: number }>
    >(
      apiPath.clients.fetchClientsAssociatedWithUser,
      data,
      showLoader
        ? undefined
        : {
            context: new HttpContext().set(LOADER_TOKEN, LoaderEnum.SPINNER),
          },
    );
  }

  public createClient = (payload: any): Observable<ApiResponse<string>> => {
    return this.http.post<ApiResponse<string>>(
      apiPath.clients.createClient,
      payload,
    );
  };

  public updateClient = (payload: any): Observable<ApiResponse<string>> => {
    return this.http.post<ApiResponse<string>>(
      apiPath.clients.updateClient,
      payload,
    );
  };

  public assignOpsManagerToClient = (
    clientId: string,
    opsManagerEmail: string,
  ): Observable<ApiResponse<string>> => {
    return this.http.post<ApiResponse<string>>(
      `${apiPath.clients.assignClient}?clientId=${clientId}&operationManagerEmail=${opsManagerEmail}`,
      null,
    );
  };

  deleteClient(clientId: string) {
    return this.http.post<ApiResponse<string>>(
      `${apiPath.clients.deleteClient}?clientId=${clientId}`,
      null,
    );
  }

  archiveUnarchiveClient(clientId: string, isActive: boolean) {
    return this.http.post<ApiResponse<string>>(
      apiPath.clients.archiveUnarchiveClient,
      null,
      {
        params: new HttpParams()
          .set('clientId', clientId)
          .set('isActive', `${isActive}`),
      },
    );
  }
}
